import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Input, ListGroup} from "reactstrap";
import InputGroup from "reactstrap/es/InputGroup";
import InputGroupAddon from "reactstrap/es/InputGroupAddon";
import InputGroupText from "reactstrap/es/InputGroupText";
import classnames from "classnames";
import {connect} from "react-redux";
import _ from "lodash";
import {FormattedMessage} from "react-intl";
import Button from "components/Button";
import api from "api";
import CheckboxIcon from "../../Components/checkboxIcon";
import QuestionContainer from "../../Components/questionContainer";
import AnswerContainer from "../../Components/answerContainer";
import IconInput from "../../Components/iconInput";

class PresentationTypeEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: '',
      checked: false,
      emailVerifySending: false,
      emailVerifyCodeSent: false,
      codeVerifing: false,
      codeCorrect: null,
      apiError: null,
      errorChecked: false,
      errorEmail: false,
      errorCode: false,
      emailChanged: false
    };

    this.emailVerify = this.emailVerify.bind(this);
    this.codeVerify = this.codeVerify.bind(this);
    this.onChangeAccetp = this.onChangeAccetp.bind(this);
    this.canShowError = this.canShowError.bind(this);
  }

  onChangeAccetp(){
    const {checked} = this.state;

    this.setState({
      checked: !checked,
    }, () => {
      this.props.onUpdated();
    });
  }

  emailVerify(){
    this.setState({
      emailVerifySending: true,
    })

    if(this.isEmailCorrect(this.props.value)){
      api.surveyResponse.questionResponse.open.email.send(this.props.surveyResponse, this.props.question, this.props.value)
          .then(data => {
            if (data && data.error) {
              this.setState({
                emailVerifySending: false,
                emailVerifyCodeSent: false,
                apiError: data.error
              })
            } else {
              this.setState({
                emailVerifySending: false,
                emailVerifyCodeSent: true,
                codeVerifing: false,
                apiError: null
              })
            }
          })
          .catch(res => {
            this.setState({
              apiError: 'api.error',
              emailVerifySending: false,
            })
          })
    }
  }

  codeVerify(){
    this.setState({
      codeVerifing: true,
      codeCorrect: null,
    })

    api.surveyResponse.questionResponse.open.email.verify(this.props.surveyResponse, this.props.question, this.props.value, this.state.code)
        .then(data => {
          this.setState({
            codeVerifing: false,
            codeCorrect: true,
            emailChanged: false
          })
        })
        .catch(res => {
          this.setState({
            codeVerifing: false,
            codeCorrect: false,
          })
        })
  }

  isEmailCorrect(email){
    const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    return regExp.test(email);
  }

  validate(){
    const {checked, codeCorrect, emailChanged} = this.state;
    const {value, validationTexts, question} = this.props;

    let validate = {
      valid: true,
      errors: []
    };

    if(value.length > 0){
      if (!this.isEmailCorrect(value)){
        validate.errors.push(validationTexts.email)
        this.setState({
          errorEmail: true
        })
      } else {
        this.setState({
          errorEmail: false
        })
      }
    } else if(question.required) {
      this.setState({
        errorEmail: true
      })
    }

    if(!checked){
      validate.errors.push(validationTexts.emailAccept)
      this.setState({
        errorChecked: true
      })
    } else {
      this.setState({
        errorChecked: false
      })
    }

    if(this.props.question.emailVerify && codeCorrect !== true && value.length > 0){
      validate.errors.push(validationTexts.emailVerify)
      this.setState({
        errorCode: true
      })
    } else {
      this.setState({
        errorCode: false
      })
    }

    validate.valid = _.isEmpty(validate.errors);

    return validate;
  }

  canShowError(value) {
    const {questionResponse} = this.props;
    if (questionResponse && questionResponse.excluding) {
      return false;
    }

    return value;
  }

  render() {
    const {value, validate, question, questionResponse} = this.props;
    const {code, codeCorrect, errorChecked, checked, emailVerifySending, emailVerifyCodeSent, errorEmail, errorCode, emailChanged} = this.state;

    return <QuestionContainer answersColumns={1}
        component={
          <React.Fragment>
            <div>
              <IconInput
                classes={"mb-3"}
                icon={<i className="fas fa-at" />}
                value={value}
                onChange={(value) => {
                  this.setState({
                    emailChanged: true
                  })
                  this.props.onChange(value)
                }}
                isError={this.canShowError(errorEmail)}
                disabled={!this.isEmailCorrect(value)}
                placeholder={this.props.intl.formatMessage({id: 'question.open.email.inputPlaceholder'})}
              />
              {this.props.question.emailVerify && <button loading={emailVerifySending} size="sm" className={classnames({
                "w-100 text-left rounded-button mt-3 mb-3": true,
                "disabled": !this.isEmailCorrect(value) || emailChanged === false
              })}
                  onClick={this.emailVerify} disabled={!this.isEmailCorrect(value)}>
                <i className="fas fa-paper-plane text-white ml-3 mr-3"/> <FormattedMessage id={"question.open.email.emailVerify.sendCode"} />
              </button>}
              {emailVerifyCodeSent &&
                  <React.Fragment>
                    {codeCorrect === true
                        ? <li className="col-12 text-success font-weight-bold text-center mt-1 mb-1"><FormattedMessage id="question.open.email.emailVerify.codeCorrect" /></li>
                        : <React.Fragment>
                          <IconInput
                              classes={"mb-3 mt-3"}
                              icon={<i className="fas fa-at" />}
                              placeholder={this.props.intl.formatMessage({id: 'question.open.email.emailVerify.enderCode.inputPlaceholder'})}
                              onChange={e => this.setState({
                                code: e.target.value
                              })}
                              value={code}
                              isError={this.canShowError(errorCode)}
                              disabled={code.length < 6}
                          />
                          <button loading={emailVerifySending} size="sm" className={classnames({
                            "w-100 text-left rounded-button mt-4 mb-3": true,
                            "disabled": code.length < 6
                          })}
                              onClick={this.codeVerify} disabled={code.length < 6}>
                            <i className="fas fa-paper-plane text-white ml-3 mr-3"/> <FormattedMessage id={"question.open.email.emailVerify.confirm"} />
                          </button>
                          {codeCorrect === false && <div className="text-danger font-weight-bold text-center pt-1"><FormattedMessage id="question.open.email.emailVerify.codeIncorrect" /></div>}
                        </React.Fragment>
                    }
                  </React.Fragment>}
              <p className={classnames({
                  'error': this.canShowError(errorChecked),
                  'mt-2': true,
                  'color-default': true
                })} onClick={this.onChangeAccetp}
              >
                <CheckboxIcon checked={checked} classes={classnames({
                  'error': this.canShowError(errorChecked),
                  "mr-3 align-self-center": true
                })}/>
                <small><FormattedMessage id="question.open.email.rodoText">{msg => msg}</FormattedMessage></small>
              </p>
            </div>
          </React.Fragment>
        }/>
  }
}

PresentationTypeEmail.propTypes = {
  question: PropTypes.shape({
    emailVerify: PropTypes.bool.isRequired,
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    surveyResponse: state.surveyResponse
  }
}

export default connect(mapStateToProps, null, null, {withRef: true, forwardRef: true})(PresentationTypeEmail);